import { useCallback, useEffect, useRef, useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";

const EMPTY = {};

export function useSticking(tab, user, shared) {
  const [map, setMap] = useState(EMPTY);
  const [source, setSource] = useState(null);
  const timer = useRef(null);

  useEffect(() => {
    const hasShared = shared && Object.keys(shared).length > 0;
    setMap(hasShared ? shared : EMPTY);
    setSource(hasShared ? "shared" : null);
    if (!user || !tab?.title) return;
    api.get("/sticking", { params: { title: tab.title, artist: tab.artist || "" } })
      .then((r) => {
        if (r.data.source === "mine" || !hasShared) { setMap(r.data.sticking || EMPTY); setSource(r.data.source); }
      })
      .catch(() => {});
  }, [user, tab?.title, tab?.artist, shared]);

  const persist = useCallback((next) => {
    clearTimeout(timer.current);
    timer.current = setTimeout(() => {
      api.put("/sticking", { title: tab.title, artist: tab.artist || "", sticking: next })
        .then(() => setSource(Object.keys(next).length ? "mine" : null))
        .catch(() => toast.error("Could not save sticking"));
    }, 600);
  }, [tab?.title, tab?.artist]);

  const setStick = useCallback((key, val) => {
    if (!user) { toast.error("Sign in to save your own sticking"); return; }
    setMap((m) => {
      const next = { ...m, [key]: val };
      persist(next);
      return next;
    });
  }, [user, persist]);

  const reset = useCallback(() => {
    if (!user) { toast.error("Sign in to save your own sticking"); return; }
    setMap(EMPTY);
    persist({});
    setSource(null);
    toast.success("Sticking reset to BeatFlow's suggestion");
  }, [user, persist]);

  return { stickMap: map, stickSource: source, setStick, resetSticking: reset };
}
